/**
 * 标签信息接口
 */
export interface Tag {
  id: number;
  name: string;
  color: string;
  category: string;
  createTime?: string;
  updateTime?: string;
}

/**
 * 新增标签请求参数
 */
export interface AddTagRequest {
  name: string;
  color: string;
  category: string;
}

/**
 * 标签分类
 */
export const TAG_CATEGORIES = [
  { label: '技术分类', value: '技术分类' },
  { label: '面试类型', value: '面试类型' },
  { label: '公司规模', value: '公司规模' },
  { label: '工作性质', value: '工作性质' },
  { label: '其他', value: '其他' }
]; 